import { Typography } from "@material-ui/core";
import React from "react";
import NameFields from "../../../Base/Components/NameFields";

export default function BirthParentsInfoForm() {
  return (
    <div role="main">
      <Typography variant="h3" className="h3-header">
        Name of Birth Parent 1 Before Marriage
      </Typography>
      <NameFields namePrefix="birthParent1Cert" />
      <Typography variant="h3" className="h3-header">
        Current Name of Birth Parent 1
      </Typography>
      <NameFields namePrefix="birthParent1Current" />
      <Typography variant="h3" className="h3-header">
        Birth Mother Alias on Birth Certificate
      </Typography>
      <NameFields namePrefix="birthMotherAlias" />
      <Typography variant="h3" className="h3-header">
        Name of Birth Parent 2 Before Marriage
      </Typography>
      <NameFields namePrefix="birthParent2Cert" />
      <Typography variant="h3" className="h3-header">
        Current Name of Birth Parent 2
      </Typography>
      <NameFields namePrefix="birthParent2Current" />
    </div>
  );
}
